import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import Axios from "axios";
import MeasureUnitHelper from "@Scripts/Infrastructure/MeasureUnitHelper";
import Localizer from "@Scripts/Common/Localizer";

@Component({ name: "CatalogueProductDetailAccessories" })
export default class CatalogueProductDetailAccessories extends Vue {
    public localizer: any = Localizer;
    public measureUnitHelper: any = MeasureUnitHelper;
    public isLoading: boolean = true;

    public product: any = null;
    public relatedProducts: any[] = [];

    get routes() {
        return (<any>window).App.routes;
    }

    get measureUnits() {
        return this.$store.getters["measureUnitStore/measureUnits"];
    }

    @Prop() readonly itemCode: string;
    @Prop() readonly itemRevision: string;
    @Prop() readonly isAuthenticated: boolean;

    public async created() {
        await this.getData();
    }

    public async getData() {
        this.isLoading = true;

        try {
            const response = (await Axios.post(this.routes.Catalogue_GetProductDetailAccessoriesData, { itemCode: this.itemCode, itemRevision: this.itemRevision })).data;

            this.product = response.product;
            this.relatedProducts = response.relatedProducts;
        } catch (error) {
            this.product = null;
            this.relatedProducts = [];
        }

        this.isLoading = false;
    }

    public setCamelCase(value: string) {
        return value.charAt(0).toLowerCase() + value.slice(1);
    }
};